import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, Truck } from "lucide-react";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import Seo from "@/components/Seo";

export default function WeeklyDrop() {
  const [data, setData] = useState({ theme_label: "", products: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/weekly-drop")
      .then(({ data }) => setData(data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] pt-28 pb-24" data-testid="weekly-drop-page">
      <Seo title="Cuts Available This Week | Dark Growers Genetics" description="This week's rooted, ready-to-ship clone cuts — ships next business day." />
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-4">
          <span className="inline-flex items-center gap-2 label-caps text-emerald-400 text-xs">
            <Sparkles size={14} /> Cuts Available This Week
          </span>
        </div>
        <h1 className="font-display text-5xl sm:text-6xl text-white text-center" data-testid="weekly-drop-theme">
          {data.theme_label || "This Week's Drop"}
        </h1>
        <p className="text-slate-400 text-sm text-center max-w-xl mx-auto mt-4 flex items-center justify-center gap-2">
          <Truck size={15} className="text-emerald-500" /> Rooted now &amp; ready to ship — these cuts leave next business day.
        </p>

        {loading ? (
          <p className="text-center text-slate-500 mt-16">Loading this week's cuts…</p>
        ) : data.products.length === 0 ? (
          <div className="text-center mt-16" data-testid="weekly-drop-empty">
            <p className="text-slate-400">No cuts are rooted and ready right now — everything is available made-to-order.</p>
            <Link to="/shop/clones" className="inline-block mt-5 bg-emerald-600 text-white hover:bg-emerald-500 transition-colors px-6 py-3 text-sm">
              Browse all clones for preorder
            </Link>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-14" data-testid="weekly-drop-grid">
            {data.products.map((p, i) => (
              <ProductCard key={p.id} product={p} index={i} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
